import usePreferencesStore from './preferencesStore';

/**
 * Updates the pinned traits for accounts in the preferences store
 * @param traits - Array of trait names to be pinned
 * @returns Promise that resolves when the update is complete
 */
export const updateAccountPinnedTraits = async (traits: string[]): Promise<void> => {
  const { preferences, updatePreferences } = usePreferencesStore.getState();
  
  if (!preferences) {
    throw new Error('Preferences not initialized. Make sure preferences are loaded before updating.');
  }
  
  const result = await updatePreferences({
    accounts: {
      ...preferences.accounts,
      pinned_traits: traits
    }
  });

  return result;
};

/**
 * Updates the pinned traits for users in the preferences store
 * @param traits - Array of trait names to be pinned
 * @returns Promise that resolves when the update is complete
 */
export const updateUserPinnedTraits = async (traits: string[]): Promise<void> => {
  const { preferences, updatePreferences } = usePreferencesStore.getState();
  
  if (!preferences) {
    throw new Error('Preferences not initialized. Make sure preferences are loaded before updating.');
  }
  
  const result = await updatePreferences({
    users: {
      ...preferences.users,
      pinned_traits: traits
    }
  });

  return result;
};

/**
 * Gets the currently pinned account traits from the preferences store
 * @returns Array of pinned account trait names or empty array if not available
 */
export const getAccountPinnedTraits = (): string[] => {
  const { preferences } = usePreferencesStore.getState();
  return preferences?.accounts?.pinned_traits || [];
};

/**
 * Gets the currently pinned user traits from the preferences store
 * @returns Array of pinned user trait names or empty array if not available
 */
export const getUserPinnedTraits = (): string[] => {
  const { preferences } = usePreferencesStore.getState();
  return preferences?.users?.pinned_traits || [];
};
